export enum Actor {
  AGENT = 'agent',
  CUSTOMER = 'customer',
  SYSTEM = 'system',
  USER = 'user',
  MISSED_CALL = 'missed_call'
}
